import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  connect() {
    this.animating = false
    this.scrollHandler = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.scrollHandler)
  }

  disconnect() {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  handleScroll() {
    // Don't change state while animating
    if (this.animating) return

    const scrollPosition = window.scrollY
    const windowHeight = window.innerHeight
    const scrollThreshold = windowHeight * 2.0

    // Show button after scrolling down one page length
    if (scrollPosition > scrollThreshold) {
      if (this.buttonTarget.classList.contains('opacity-0') || this.buttonTarget.classList.contains('hidden')) {
        this.showButton()
      }
    } else {
      if (!this.buttonTarget.classList.contains('opacity-0') && !this.buttonTarget.classList.contains('hidden')) {
        this.hideButton()
      }
    }
  }

  showButton() {
    this.animating = true
    this.buttonTarget.classList.remove('hidden')

    setTimeout(() => {
      this.buttonTarget.classList.remove('opacity-0')
    }, 10)
    setTimeout(() => {
      this.animating = false
    }, 200)
  }

  hideButton() {
    this.animating = true
    this.buttonTarget.classList.add('opacity-0')
    
    setTimeout(() => {
      this.buttonTarget.classList.add('hidden')
      this.animating = false
    }, 200)
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
}
